import { useState } from 'react';
import styles from './CourseGridEnrolled.module.css';
import CourseCardEnrolled from "../course-card-enrolled/CourseCardEnrolled.tsx";
import CourseProgressRing from "../course-progress-ring/CourseProgressRing.tsx";

const FILTERS = ['All', 'Frontend', 'Backend', 'Data Science', 'Business'];
const LEVEL_ORDER = { Beginner: 0, Intermediate: 1, Advanced: 2 };

function CourseGridEnrolled(props) {
  const [filter, setFilter] = useState('All');
  const [sort, setSort] = useState('progress');

  const filterCourses = (courses) => {
    if (filter === 'All') {
      return courses;
    }
    return courses.filter((course) => course.category === filter);
  };

  const sortCourses = (courses) => {
    if (sort === 'progress') {
      return courses.sort((a, b) => {
        const progressA = a.completed_lessons / a.total_lessons;
        const progressB = b.completed_lessons / b.total_lessons;
        return progressB - progressA;
      });
    }
    if (sort === 'level') {
      return courses.sort((a, b) => LEVEL_ORDER[a.level] - LEVEL_ORDER[b.level]);
    }
    if (sort === 'title') {
      return courses.sort((a, b) => a.title.localeCompare(b.title));
    }
    return courses;
  };

  const filteredCourses = filterCourses(props.courses);
  const sortedCourses = sortCourses(filteredCourses);

  let totalCompleted = 0;
  let totalLessons = 0;
  let doneLessons = 0;
  let overallPercent = 0;

  props.courses.forEach((course) => {
    if (course.completed_lessons === course.total_lessons) {
      totalCompleted++;
    }

    totalLessons += course.total_lessons;
    doneLessons += course.completed_lessons;
  });

  if(totalLessons > 0) {
    overallPercent = Math.round((doneLessons / totalLessons) * 100);
  }

  return (
    <div className="container">

      <main className={styles.main}>

        {/* ── Hero summary ── */}
        <div className={styles.summary}>
          <div className={styles.summaryText}>
            <h1 className={styles.summaryHeading}>My Learning</h1>
            <p className={styles.summarySubheading}>
              {totalCompleted} of {props.courses.length} courses complete · {doneLessons} of {totalLessons} lessons done
            </p>
          </div>
          <div className={styles.summaryRing}>
            <CourseProgressRing percent={overallPercent} color="var(--vc-primary)" size={72} />
            <span className={styles.summaryRingLabel}>Overall</span>
          </div>
        </div>

        {/* ── Toolbar ── */}
        <div className={styles.toolbar}>
          <div className={styles.filters}>
            {FILTERS.map((f) => (
              <button
                key={f}
                className={`${styles.filterBtn} ${filter === f ? styles.filterActive : ''}`}
                onClick={() => setFilter(f)}
              >
                {f}
              </button>
            ))}
          </div>
          <div className={styles.sortWrap}>
            <label className={styles.sortLabel} htmlFor="sort">Sort by</label>
            <select
              id="sort"
              className={styles.sortSelect}
              value={sort}
              onChange={(e) => setSort(e.target.value)}
            >
              <option value="progress">Progress</option>
              <option value="title">Title</option>
              <option value="level">Level</option>
            </select>
          </div>
        </div>

        {/* ── Grid ── */}
        <div className={styles.grid}>
          {filteredCourses.map((course) => (
            <CourseCardEnrolled key={course.id} course={course} />
          ))}
        </div>

      </main>
    </div>
  );
}

export default CourseGridEnrolled;
